import * as yup from 'yup'
import { getRequiredSchema } from 'src/deps'

const cancelReason = props => {
  const inputName = props.isCancel ? 'cancellationReason' : 'returnReason'
  let schemaData = {}
  if (props.isRequired) {
    Object.assign(
      schemaData,
      getRequiredSchema({
        requiredType: 'reasonCode',
        inputName,
      })
    )
  }
  return schemaData
}

export const schema = props => {
  return yup.object(cancelReason(props))
}
